import clsx from 'clsx';
import { LitElement } from 'lit';
import { LocalizeMixin } from '@italia/i18n';
import { Logger } from '../utils/logger.js';
/**
 * Factory function per creare una base class estendibile
 * con stili personalizzati.
 */
export class BaseComponent extends LitElement {
    constructor() {
        super();
        this.composeClass = clsx;
        this.logger = new Logger(this.tagName.toLowerCase());
    }
    get _ariaAttributes() {
        const attributes = {};
        for (const attr of this.getAttributeNames()) {
            if (attr === 'it-role') {
                attributes.role = this.getAttribute(attr);
            }
            else if (attr.startsWith('it-aria-')) {
                attributes[attr.replace(/^it-/, '')] = this.getAttribute(attr);
            }
        }
        return attributes;
    }
    // eslint-disable-next-line class-methods-use-this
    generateId(prefix) {
        return `${prefix}-${Math.random().toString(36).slice(2)}`;
    }
    // eslint-disable-next-line class-methods-use-this, @typescript-eslint/no-unused-vars
    addFocus(element) {
        // new TrackFocus(element); // per il momento è stato disattivato perchè ci sono le pseudo classi ::focus-visible per fare quello che fa TrackFocus. Si possono aggiungere regole css in bsi-italia 3 dato che stiamo facendo una breaking release di bsi.
    }
    // eslint-disable-next-line class-methods-use-this
    getActiveElement() {
        let active = document.activeElement;
        while (active && active.shadowRoot && active.shadowRoot.activeElement) {
            active = active.shadowRoot.activeElement;
        }
        return active;
    }
    get focusElement() {
        return this;
    }
    // eslint-disable-next-line class-methods-use-this
    get prefersReducedMotion() {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }
    connectedCallback() {
        super.connectedCallback();
        // generate internal _id
        const prefix = this.id?.length > 0 ? this.id : this.tagName.toLowerCase();
        this._id = this.generateId(prefix);
        this.ariaAttributesObserver = new MutationObserver((mutations) => {
            const shouldUpdate = mutations.some((mutation) => {
                if (mutation.type !== 'attributes' || !mutation.attributeName) {
                    return false;
                }
                return mutation.attributeName === 'it-role' || mutation.attributeName.startsWith('it-aria-');
            });
            if (shouldUpdate) {
                this.requestUpdate();
            }
        });
        this.ariaAttributesObserver.observe(this, {
            attributes: true,
            attributeOldValue: true,
        });
    }
    disconnectedCallback() {
        this.ariaAttributesObserver?.disconnect();
        this.ariaAttributesObserver = undefined;
        super.disconnectedCallback();
    }
}
export const BaseLocalizedComponent = LocalizeMixin(BaseComponent);
//# sourceMappingURL=base-component.js.map